import { z } from "zod";

import {
  contactFormSectionSchema,
  ctaBannerSectionSchema,
  heroSectionSchema,
  pageSeoSchema,
  resourcesSectionSchema,
} from "@/content/schemas";
import { siteConfig } from "@/content/site";
import { validateContent } from "@/content/validateContent";

const contactPageSchema = z.object({
  seo: pageSeoSchema,
  hero: heroSectionSchema,
  contactChannels: resourcesSectionSchema,
  formSection: contactFormSectionSchema,
  finalCta: ctaBannerSectionSchema,
});

export const contactPageContent = validateContent("contactPage", contactPageSchema, {
  seo: {
    title: "Contact | Tech Savvy Starts Here",
    description: "Get in touch about partnerships, speaking, training, or workshop questions.",
    canonicalPath: "/contact",
    socialImage: "/social-card.svg",
  },
  hero: {
    eyebrow: "Contact",
    title: "Let’s Start",
    accent: "a Conversation",
    description:
      "Use the contact form below for partnership, speaking, and training inquiries, or reach out directly by email.",
    primaryCta: {
      label: "Email Directly",
      href: `mailto:${siteConfig.email}`,
      external: true,
    },
  },
  contactChannels: {
    title: "Ways to connect",
    description: "Keep the page simple, useful, and easy to maintain.",
    cards: [
      {
        icon: "Mail",
        title: "Email",
        description: "Reach out directly for questions, workshop support, or collaboration inquiries.",
        cta: {
          label: siteConfig.email,
          href: `mailto:${siteConfig.email}`,
          external: true,
        },
      },
      {
        icon: "MessageCircle",
        title: "Partnerships, speaking, and training",
        description: "Use the form below to share what you are planning and how you would like to work together.",
        cta: {
          label: "Use the contact form",
          href: "/contact#send-inquiry",
          external: false,
        },
      },
    ],
  },
  formSection: {
    title: "Send an inquiry",
    description: "Use this simple form to reach out.",
    intro:
      "If a live form endpoint is added later, this form can submit there directly. For now, it falls back to email so the site remains static and easy to deploy.",
    submitLabel: "Send Inquiry",
    successMessage: "Your message is ready to send. If your email app did not open, contact us directly by email.",
    fields: [
      {
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Your name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        placeholder: "you@example.com",
      },
      {
        name: "inquiry",
        label: "How can we help?",
        type: "textarea",
        placeholder: "Tell us about your partnership, speaking, training, or workshop inquiry.",
      },
    ],
  },
  finalCta: {
    title: "Prefer to connect through the content first?",
    description: "Explore the newsletter and YouTube channel, then reach out when you are ready to work together.",
    primaryCta: {
      label: "Go to Newsletter",
      href: "/newsletter",
      external: false,
    },
    secondaryCta: {
      label: "Watch on YouTube",
      href: "/youtube",
      external: false,
    },
    tone: "light",
  },
});
